import React, { createContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isPreviewSite, privateSearchPage } from "../lib/publicSite";

export const SearchPrivacyContext = createContext(null);

export const SearchPrivacy = ({ children }) => {
    const location = useLocation();
    const [pagePolicy, setPagePolicy] = useState(null);
    // A page override applies only to its current navigation, never the next page.
    const noIndex = isPreviewSite() || privateSearchPage(location.pathname, location.search)
        || (pagePolicy?.key === location.key && pagePolicy.noIndex);
    return <SearchPrivacyContext.Provider value={setPagePolicy}>
        <Helmet><meta name="robots" content={noIndex ? "noindex,nofollow" : "index,follow,max-image-preview:large"} /></Helmet>
        {children}
    </SearchPrivacyContext.Provider>;
};